export default __webpack_public_path__ + "static/media/paymentMethodDPO.72e41235.png";